import slice from 'store/features/cache/slice'

const { actions } = slice

export const cacheThunks = { ...actions }
